import mutations from './mutationProduct.js'
import actions from './actionProduct.js'

export default {
  state: {
    products: {},
    product: {}
  },
  mutations,
  actions
}
